export default function getSportType(state) {
  return state.sport.sportName.toLowerCase();
}
